import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "triangle-arrow-right",
  "use": "triangle-arrow-right-usage",
  "viewBox": "0 0 17 18",
  "content": "<symbol viewBox=\"0 0 17 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"triangle-arrow-right\">\n  <path d=\"M2.93846 0.396885C1.31566 -0.533975 0 0.228597 0 2.09878V15.8999C0 17.7719 1.31566 18.5335 2.93846 17.6035L15.0013 10.6856C16.6247 9.75437 16.6247 8.24571 15.0013 7.31473L2.93846 0.396885Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol